import { useState, useEffect } from "react";
import api from "../services/api";

const MESES = ["", "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
               "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
const BADGE = { COMISSAO: "primary", PREMIO: "warning", PRODUTIVIDADE: "success" };
const fmt = (v) => v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

async function downloadRelatorio(calcId, formato, nomeVendedor, mes, ano) {
  try {
    const { data } = await api.get(
      `/relatorios/historico/${calcId}/relatorio/${formato}`,
      { responseType: "blob" }
    );
    const ext = formato === "excel" ? "xlsx" : "pdf";
    const nome = nomeVendedor.replace(/ /g, "_");
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `relatorio_${nome}_${String(mes).padStart(2, "0")}_${ano}.${ext}`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    alert("Erro ao gerar relatório.");
  }
}

export default function Historico() {
  const [calculos, setCalculos] = useState([]);
  const [ano, setAno] = useState("");
  const [mes, setMes] = useState("");
  const role = localStorage.getItem("role");

  const load = () => {
    const p = new URLSearchParams();
    if (ano) p.append("ano", ano);
    if (mes) p.append("mes", mes);
    api.get("/historico?" + p).then(({ data }) => setCalculos(data));
  };

  useEffect(() => { load(); }, [ano, mes]);

  const deleteCalculo = async (id) => {
    if (!window.confirm("Excluir este calculo do historico? Esta acao e irreversivel.")) return;
    try { await api.delete("/historico/" + id); load(); }
    catch (err) { alert(err.response?.data?.detail || "Erro ao excluir calculo"); }
  };

  return (
    <div>
      <h4 className="fw-bold mb-3">Historico de Calculos</h4>
      <div className="row g-2 mb-3">
        <div className="col-auto">
          <select className="form-select" value={mes} onChange={(e) => setMes(e.target.value)}>
            <option value="">Todos os meses</option>
            {MESES.slice(1).map((m, i) => (
              <option key={i + 1} value={i + 1}>{m}</option>
            ))}
          </select>
        </div>
        <div className="col-auto">
          <input type="number" className="form-control" placeholder="Ano"
            value={ano} onChange={(e) => setAno(e.target.value)} style={{ width: 100 }} />
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-sm">
          <thead className="table-dark">
            <tr>
              <th>Data/Hora</th><th>Calculado por</th><th>Vendedor</th><th>Mes/Ano</th><th>Tipo</th>
              <th>Com. Auferida</th><th>Remuner. %</th><th>Remuner. R$</th>
              <th>Premio R$</th><th>Produt. R$</th><th>Beneficios</th><th>Resultado</th>
              <th>Relatório</th>
              {role === "admin" && <th></th>}
            </tr>
          </thead>
          <tbody>
            {calculos.map((c) => {
              const pos = c.resultado > 0.01;
              return (
                <tr key={c.id}>
                  <td className="small">
                    {new Date(c.data_hora + "Z").toLocaleDateString("pt-BR")}
                    <br/>
                    <span className="text-muted">
                      {new Date(c.data_hora + "Z").toLocaleTimeString("pt-BR", {hour:"2-digit",minute:"2-digit"})}
                    </span>
                  </td>
                  <td className="small">{c.usuario?.username || <span className="text-muted fst-italic">Não disponível</span>}</td>
                  <td>
                    {c.vendedor?.nome}
                    {c.limite_repasse_aplicado && (
                      <span className="badge bg-warning text-dark ms-1"
                        title={"Cap aplicado. % sem limite: " + c.pct_sem_limite?.toFixed(4) + "%"}>
                        ⚠️ Cap
                      </span>
                    )}
                  </td>
                  <td>{MESES[c.mes]}/{c.ano}</td>
                  <td><span className={"badge bg-" + (BADGE[c.tipo_remuneracao] || "secondary")}>{c.tipo_remuneracao}</span></td>
                  <td>{fmt(c.producao)}</td>
                  <td>{c.remuneracao_percentual?.toFixed(4)}%</td>
                  <td>{fmt(c.remuneracao_variavel)}</td>
                  <td>{fmt(c.premio_valor)}</td>
                  <td>{fmt(c.produtividade_valor)}</td>
                  <td>{fmt(c.beneficios)}</td>
                  <td className={pos ? "text-primary fw-bold" : "text-success fw-bold"}
                    title={pos ? "Limite de repasse aplicado" : "Resultado zero"}>
                    {fmt(c.resultado)}
                  </td>
                  <td className="text-nowrap">
                    <button
                      className="btn btn-sm btn-outline-success me-1"
                      title="Baixar relatório Excel"
                      onClick={() => downloadRelatorio(c.id, "excel", c.vendedor?.nome || "vendedor", c.mes, c.ano)}
                    >
                      📊
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      title="Baixar relatório PDF"
                      onClick={() => downloadRelatorio(c.id, "pdf", c.vendedor?.nome || "vendedor", c.mes, c.ano)}
                    >
                      📄
                    </button>
                  </td>
                  {role === "admin" && (
                    <td>
                      <button className="btn btn-sm btn-outline-danger" title="Excluir calculo"
                        onClick={() => deleteCalculo(c.id)}>🗑️</button>
                    </td>
                  )}
                </tr>
              );
            })}
            {calculos.length === 0 && (
              <tr><td colSpan={role === "admin" ? 15 : 14} className="text-center text-muted py-3">
                Nenhum calculo encontrado.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
